import React, {useState} from 'react';
import { Add } from '@mui/icons-material';
import { getBookData, getPageData } from "utils/lib/ebookHelper";
import { useUserRole } from "store/users/selectors";
import AssignmentForm from "features/forms/AssignmentForm";
import styles from './FeaturesModuleStyling.module.css';

const PodcastAddAssignment = ({
    isDrawerOpen,
    currentClass,
    currentUser,
    id,
    quiz,
    activity,
    notes,
    section,
    tipsBook,
    quizzes,
    activities,
    classQuizzes,
    interactions,
    classActivities,
    setSubmitRef,
    timmer,
    onFinish,
    booksAllList,
    videoInfo,
    track,
    engTrack,
    title,
    listenActions,
    timeInt,
    handleOpenStoryWithAi = () => {},
    hasStoryWithAi,
    onGenerateClick = () => {},
    handlerOpenPresentation = () => {},
    has_all_page
  }) => {

    const { is_student, is_teacher, is_admin } = useUserRole();

    const bookData = getBookData(activities, quizzes, null, notes, null, interactions, classActivities, classQuizzes, id,currentClass?.id,false,currentUser?.id)
    const pageData = getPageData(bookData, id, quiz, activity)

    const activeActivity = pageData?.activeActivity;
    const activeQuiz = pageData?.activeQuiz;
    const [customAssignmentDrawer, setCustomAssignmentDrawer] = useState(false);

    const hasActiveAssignmentDrawer = () => {
        const hasActiveQz = activeActivity || activeQuiz
        return (typeof quiz == "string" && quiz.length > 2 && quiz !== 'null') || (typeof activity == "string" && activity.length > 2 && activity !== 'null' && hasActiveQz)
      }
    const isTeacher = is_teacher;

  return (
    <>
    { (!hasActiveAssignmentDrawer() && isTeacher) && (
        <>
            {customAssignmentDrawer ? <AssignmentForm open={customAssignmentDrawer} onClose={() => setCustomAssignmentDrawer(false)} bookId={id} pageId={id} pageSrc={''} formResource="resource" /> : null}

            <button className={styles.podcastAssignmentButtion}
                onClick={() => setCustomAssignmentDrawer(true)}
            >
                <div className={styles.podcastAssignmentButtionInner}>
                    <Add style={{ fontSize: '13px', fontWeight: 700 }} /> Add Assignment
                </div>
            </button>
        </>
    )}
  </>
  )
}

export default PodcastAddAssignment